import { useQuery } from 'react-query';

import { getTopRelationshipCountChanges as queryFn } from 'api/endPoints/getTopRelationshipCountChanges';

export const useQueryRelationshipCountChangesTableData = (params) => {
    return useQuery(['relationshipCountChangesTableData', params], () => queryFn(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
